export const environmentShared = {
	version: '0.7.36',
	updateDate: '02/03/2023',
	apiKey: '',
	environmentName: 'LIVE',
	apiBaseUrl: 'https://europe-west1-live-bwrm-processor-prism.cloudfunctions.net',
  assetServiceUrl: 'https://assets.api.bwrm.com/api/v1/processor-assets',
  baseUrl: 'https://processor.bwrm.com',
	lastVisitedAddressKey: 'lastAddress',
};
